import dayjs from 'dayjs';
import { FormItem } from 'components/use-form';
import { AgencyInfo, ContactInfo } from 'model/agency';
import { AGENCYTYPE, COMPANYSCALE } from 'pages/regist/const/constant';

export const agencyInfoFormConfig: Array<FormItem> = [
  {
    name: 'agency_name',
    label: '服务商名称',
  },
  {
    name: 'company_service_type',
    label: '服务类型',
    render: (data: AgencyInfo) => {
      return AGENCYTYPE[data.company_service_type || ''] || '-';
    },
  },
  {
    name: 'company_business',
    label: '公司主营业务',
  },
  {
    name: 'company_area_code_name',
    label: '公司所在地',
  },
  {
    name: 'company_address',
    label: '公司地址',
  },
  {
    name: 'company_introduction',
    label: '公司简介',
    type: 'textArea',
  },
  {
    name: 'company_homepage',
    label: '公司网址',
    type: 'link',
  },
  {
    name: 'company_population',
    label: '公司规模',
    render: (data: AgencyInfo) => {
      return COMPANYSCALE[data.company_population || ''] || '-';
    },
  },
  {
    name: 'company_created_time',
    label: '公司成立时间',
    render: (data: AgencyInfo) => {
      return data.company_created_time ? dayjs(data.company_created_time).format('YYYY-MM-DD') : '-';
    },
  },
  {
    name: 'company_team',
    label: '团队构成',
    type: 'textArea',
  },
];

export const contactInfoFormConfig = [
  {
    name: 'manager_name',
    label: '联系人姓名',
  },
  {
    name: 'manager_mobile',
    label: '联系人电话',
  },
  {
    name: 'manager_qq',
    label: '联系人QQ',
    display: (data: ContactInfo) => {
      return data.manager_type === 'qq';
    },
  },
  {
    name: 'manager_wx',
    label: '联系人微信',
    display: (data: ContactInfo) => {
      return data.manager_type === 'wx';
    },
  },
  {
    name: 'manager_email',
    label: '联系人邮箱',
  },
  {
    name: 'authorize_file',
    type: 'file',
    label: '开户账号使用授权书',
  },
];
